import React, { useState, useEffect } from "react";
import { FaEnvelope, FaPhoneAlt, FaBars } from "react-icons/fa";
import { Link } from "react-router-dom";


import logoPutih from "../assets/logo/logoputih.png";
import logoHitam from "../assets/logo/logohitam.png";

const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [currentTime, setCurrentTime] = useState(new Date());
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener("scroll", handleScroll);

    const timer = setInterval(() => {
      setCurrentTime(new Date());
    }, 1000);

    return () => {
      window.removeEventListener("scroll", handleScroll);
      clearInterval(timer);
    };
  }, []);

  return (
    <header style={{ position: "fixed", top: 0, left: 0, right: 0, zIndex: 100 }}>
      {/* Topbar (hilang di mobile) */}
      <div className="topbar">
        <div style={{ display: "flex", gap: "1rem", flexWrap: "wrap", alignItems: "center" }}>
          {/* Email */}
          <div style={{ display: "flex", alignItems: "center", gap: "0.5rem" }}>
            <FaEnvelope />
            <a
              href="https://mail.google.com/mail/?view=cm&fs=1&to=idawidaningsihppat@gmail.com&su=Halo&body=Halo%20saya%20ingin%20bertanya"
              target="_blank"
              rel="noopener noreferrer"
              style={{ color: "white", textDecoration: "none" }}
            >
              idawidaningsihppat@gmail.com
            </a>
          </div>

          {/* Pemisah */}
          <div className="separator"></div>

          {/* WA */}
          <div style={{ display: "flex", alignItems: "center", gap: "0.5rem" }}>
            <FaPhoneAlt />
            <a
              href="https://wa.me/6281398591722?text=Halo%20saya%20ingin%20bertanya"
              target="_blank"
              rel="noopener noreferrer"
              style={{ color: "white", textDecoration: "none" }}
            >
              (+62) 813-9859-1722
            </a>
          </div>
        </div>

        {/* Waktu realtime */}
        <div>
          {currentTime.toLocaleDateString("en-GB", {
            weekday: "long",
            year: "numeric",
            month: "long",
            day: "numeric",
          })}{" "}
          - {currentTime.toLocaleTimeString("en-GB")}
        </div>
      </div>

      {/* Main Navbar */}
      <nav
        className="main-navbar"
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          padding: "0.8rem 1rem",
          // background: scrolled ? "white" : "#1E293B",
          background: scrolled ? "white" : "#4e4f4d",
          color: scrolled ? "#0f172a" : "white",
          transition: "all 0.3s ease-in-out",
        }}
      >
        {/* Logo */}
        <img
          src={scrolled ? logoHitam : logoPutih}
          alt="Company Logo"
          style={{ height: "60px", objectFit: "contain" }}
        />

        {/* Hamburger button (mobile only) */}
        <div className="menu-toggle" onClick={() => setMenuOpen(!menuOpen)}>
          <FaBars size={24} />
        </div>

        {/* Menu (desktop) */}
        <div className="menu-links">
           <Link to="/">HOME</Link>
           <Link to="/about">ABOUT US</Link>
           <Link to="/service">SERVICES</Link>
           <Link to="/product">PRODUCT</Link>
           <Link to="/contact">CONTACT US</Link>
        </div>
      </nav>

      {/* Floating menu (mobile only) */}
      {menuOpen && (
        <div className="floating-menu">
          <form className="floating-form">
            <Link to="/" onClick={() => setMenuOpen(false)}>HOME</Link>
            <Link to="/about" onClick={() => setMenuOpen(false)}>ABOUT US</Link>
            <Link to="/service" onClick={() => setMenuOpen(false)}>SERVICES</Link>
            <Link to="/product" onClick={() => setMenuOpen(false)}>PRODUCT</Link>
            <Link to="/contact" onClick={() => setMenuOpen(false)}>CONTACT US</Link>
          </form>
        </div>
      )}


      {/* CSS */}
      <style>{`
        .topbar {
          background: #1d7d37;
          color: white;
          font-size: 0.9rem;
          display: flex;
          justify-content: space-between;
          padding: 0.5rem 1rem;
          border-bottom: 0.5px solid orange; /* tipis */
        }

        .separator {
          border-left: 0.5px solid orange; /* tipis */
          height: 18px;
        }

        .menu-toggle {
          display: none;
          cursor: pointer;
          -webkit-tap-highlight-color: transparent;
        }
        .menu-toggle:hover,
        .menu-toggle:focus,
        .menu-toggle:active {
          background: none !important;
          color: inherit !important;
          outline: none !important;
        }

        .menu-links {
          display: flex;
          gap: 2rem;
          font-weight: 600;
        }

        .menu-links a {
          text-decoration: none;
          color: inherit;
        }

        .main-navbar {
          border-top: 1px solid rgba(255, 165, 0, 0.4); /* tipis halus orange */
        }


        /* Floating menu */
        .floating-menu {
          position: fixed;
          top: 80px;
          left: 0;
          right: 0;
          z-index: 99;
          display: flex;
          justify-content: center;
        }

        .floating-form {
          background: white;
          color: #0f172a;
          display: flex;
          flex-direction: column;
          gap: 1rem;
          padding: 1.5rem;
          border-radius: 12px;
          font-weight: 600;
          box-shadow: 0 4px 12px rgba(0,0,0,0.15);
          width: 80%;
          max-width: 400px;
        }

        .floating-form a {
          text-decoration: none;
          color: inherit;
          padding: 0.5rem 0;
          border-bottom: 1px solid #e5e7eb;
        }
        .floating-form a:last-child {
          border-bottom: none;
        }

        /* Mobile Mode */
        @media (max-width: 768px) {
          .topbar {
            display: none; /* hilang di mobile */
          }
          .menu-toggle {
            display: block;
          }
          .menu-links {
            display: none;
          }
          .main-navbar {
            border-top: none; /* mobile jangan ada garis */
          }
        }
      `}</style>
    </header>
  );
};

export default Navbar;
